module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (166).21f19e1f.jpg";